import {mapState} from "vuex";
import constant from "@/configs/constant";
export default {
  computed: {
    ...mapState("options", ["system_codes"]),
  },
  methods: {
    findReservationStartTimeAm() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.reservation_start_time_am);
    },
    findReservationStartTimePm() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.reservation_start_time_pm);
    },
    findTimezoneStart() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.time_zone_display_setting_start);
    },
    findTimezoneEnd() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.time_zone_display_setting_finish);
    },
    findDayAlert() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.day_for_daily_report);
    },
    findLimitReceiveReplyInquiry() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.receive_reply);
    },
    findMaxReservationMonths() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.max_reservation_months);
    },
    findMaxReservationNums() {
      return this.system_codes.find(x => x.zz_system_code_category_id.toString() === constant.zz_system_code_categories.max_reservation_nums);
    }
  }
};
